import AdminConfig from './admin.vue';

import ClientView from './client.vue';


export default {
  name : 'ged',

  type : 'module',
  
  label: 'Stockage de document sur Cloud',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-file-document-arrow-right',
  }
}